export default __webpack_public_path__ + "static/media/marauders-map-v3-04-03.acd110b0.jpg";